
angular
.module('index')

	// Map view controller
	.controller('EventSurveyController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, $q, SurveyInfo, ParticipantShortCode) {

		var self = this;		
		self.survey = null;
		self.surveyErrorMessage = null;
		self.surveySaved = false;
		self.surveyIsActive = false;		
		self.formFields = [
			{
				editable:"true",
				groups:['survey-form'],
				name: 'form_data',
				required: false,
				title: '',
				type: 'FormResultsField',
				visible:"true",
				client: {
					formLabelClass: "text-left",
					formEditorClass: "",
					child_box_template_url: 'partials/index/field-box.html',
					box_template_url: 'partials/index/field-box.html',
				}
			}
		];
		self.formLayout = ['survey-form'];
		self.formValues = {}
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.ApiRootUrl = ApiRootUrl;
		
		this.isSurveyActive = function(){
			
			if(!self.survey)
				return;
			
			var now = new Date();
			var start = new Date(self.survey.visible_start);
			var end = new Date(self.survey.visible_end);
			
			if(now >= start && now <= end )
				self.surveyIsActive = true;
			else
				self.surveyErrorMessage = {type:'danger', body: 'Survey is inactive'};
		}
		
		if(SurveyInfo.error){
			self.surveyErrorMessage = {type:'danger', body: SurveyInfo.error.data.message};
		}else if(SurveyInfo.survey_form){
			self.survey = SurveyInfo.survey_form;
			self.formValues['form_data'] = SurveyInfo.survey_form.form;
			MetaService.setTitle(SurveyInfo.survey_form.title);
			self.isSurveyActive();
		}
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Save survey
				return Classes.SurveyFormItem.submit_event_survey({
					form_data: data.form_data, 
					participant_code: ParticipantShortCode
				}).then(function(resp){
					self.surveyErrorMessage = null;
					self.form.values = [];
					self.surveySaved = true;
					self.scrollToFormChapter();
				}).catch(function(e){
					self.surveyErrorMessage = {type:'danger', body: e.data.message};
					self.scrollToFormChapter();
					return $q.reject(e);
				});
				
			},
		}, self.formValues);
		
		this.scrollToFormChapter = function(){
			angular.element(window).scrollTop($("#form-chapter").offset().top - 80);
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    });
